export default __webpack_public_path__ + "static/irada-og-c50012bae1450816fe79de89c3d8e617.png";